import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import {
  selectMailerLayoutCurrentTab,
  setIsDanger,
  selectMailerLayoutSearchQuery,
  setSearchQuery,
} from 'redux/reducers/mailerLayoutReducer';
import './index.scss';
import { Col, Row } from 'react-bootstrap';
import Searcher from 'components/DesignSystem/Searcher';
import { onTextChange } from 'helper/controlledField';
import TabbedPage from 'components/TabbedPage';
import MobileSectionHeader from 'components/Layout/MobileShell/MobileSectionHeader';
import SectionTabs from 'components/Layout/MobileShell/SectionTabs';
import MoreSheet from 'components/Layout/MobileShell/MoreSheet';
import useIsMobile from 'utils/hooks/useIsMobile';
import MAILER_SECTION_TABS from 'constants/mailerSectionTabs';
import { store } from 'redux/store';

export default function MailerLayout() {
  const currentTab = useSelector(selectMailerLayoutCurrentTab);
  const [searchBarText, setSearchBarText] = useState('');
  const onSearch = (searchQuery: string) => (
    store.dispatch(setSearchQuery(searchQuery))
  );
  const searchQuery: string = useSelector(selectMailerLayoutSearchQuery);
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const [moreOpen, setMoreOpen] = useState(false);

  useEffect(() => {
    setSearchBarText(searchQuery);
  }, [searchQuery]);

  useEffect(() => { store.dispatch(setIsDanger(false)); }, []);

  if (isMobile) {
    return (
      <div className="mailer-mobile">
        <MobileSectionHeader
          backLabel="Administração"
          title="Mailer"
          onBack={() => navigate('/admin')}
          onAvatarClick={() => setMoreOpen(true)}
        />
        <SectionTabs tabs={MAILER_SECTION_TABS} sheetTitle="Mailer" />

        <div className="mailer-mobile-content">
          <Searcher
            className="mailer-mobile-search"
            value={searchBarText}
            onChange={onTextChange(setSearchBarText)}
            placeholder="Pesquisar"
            setSearchQuery={onSearch}
            disabled={currentTab === 'templates'}
            id="mailer-mobile-search"
          />
          <Outlet />
        </div>

        <MoreSheet open={moreOpen} dismiss={() => setMoreOpen(false)} />
      </div>
    );
  }

  return (
    <>
      <Row>
        <Col className="md-6">
          <h2 className="mailerTitle mb-3">MAILER</h2>
        </Col>
        <Col>
          <Searcher
            value={searchBarText}
            onChange={onTextChange(setSearchBarText)}
            placeholder="Pesquisar"
            setSearchQuery={onSearch}
            disabled={currentTab === 'templates'}
          />
        </Col>
      </Row>
      <TabbedPage>
        <TabbedPage.Tab title="RELATÓRIOS" path="/admin/mailer/reports" />
        <TabbedPage.Tab title="E-MAIL EM MASSA" path="/admin/mailer/mass-emails" />
        <TabbedPage.Tab title="TEMPLATES" path="/admin/mailer/templates" />
      </TabbedPage>
    </>
  );
}
